
import { BirdieRecord } from "@/types";
import { Button } from "@/components/ui/button";
import { Edit, Trash2, Loader2 } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface BirdieHistoryProps {
  birdieRecords: BirdieRecord[];
  onEdit: (record: BirdieRecord) => void;
  onDelete: (record: BirdieRecord) => void;
  isLoading?: boolean;
}

const BirdieHistory = ({ 
  birdieRecords, 
  onEdit, 
  onDelete,
  isLoading = false
}: BirdieHistoryProps) => {
  const isMobile = useIsMobile();
  
  if (birdieRecords.length === 0) {
    return null;
  }
  
  return (
    <div className="mt-4">
      <h3 className={`font-medium ${isMobile ? 'text-sm' : ''}`}>History for this hole</h3>
      
      {isLoading ? (
        <div className="flex justify-center items-center py-8">
          <Loader2 className="h-8 w-8 animate-spin text-forest" />
        </div>
      ) : (
        <div className="max-h-60 overflow-y-auto mt-2 border rounded-md">
          {birdieRecords.map((record) => (
            <div
              key={record.id}
              className="p-3 border-b last:border-b-0 flex justify-between items-center"
            >
              <div>
                <p className={`font-medium ${isMobile ? 'text-xs' : 'text-sm'}`}>
                  {new Date(record.date).toLocaleDateString()} - {record.teeBox} tees
                </p>
                {record.notes && (
                  <p className={`text-muted-foreground ${isMobile ? 'text-[10px]' : 'text-xs'}`}>
                    {record.notes.substring(0, 50)}
                    {record.notes.length > 50 ? "..." : ""}
                  </p>
                )}
              </div>
              <div className="flex gap-1">
                <Button
                  variant="ghost"
                  size="sm"
                  className={`px-1 h-7 ${isMobile ? 'w-6' : 'w-8'}`}
                  onClick={() => onEdit(record)}
                  disabled={isLoading}
                >
                  <Edit className={isMobile ? 'h-3 w-3' : 'h-4 w-4'} />
                </Button>
                <Button
                  variant="ghost"
                  size="sm" 
                  className={`px-1 h-7 ${isMobile ? 'w-6' : 'w-8'} text-red-500 hover:text-red-700 hover:bg-red-50`}
                  onClick={() => onDelete(record)}
                  disabled={isLoading}
                >
                  <Trash2 className={isMobile ? 'h-3 w-3' : 'h-4 w-4'} />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BirdieHistory;
